export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_49',
	providers: {
		paltaMap: {},
	},
	otp: {
		priceMap: {
			USD: 49,
			EUR: 49,
			GBP: 49,
			AUD: 79,
			CAD: 49,
			DKK: 429,
			SEK: 659,
			NOK: 659,
			BRL: 329,
			MXN: 839,
			TRY: 1599,
			ARS: 63990,
			COP: 195990,
			CLP: 44990,
		},
	},
}
